import React from 'react';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';

import './Gallery.scss';
import { routes } from 'routing/routes';

import breaker1 from '../../assets/img/break28.jpg';
import breaker2 from '../../assets/img/break27.jpg';
import breaker3 from '../../assets/img/break23.jpg';

import egg1 from '../../assets/img/egg/egg5.jpg';
import egg2 from '../../assets/img/egg/egg3.jpg';
import egg3 from '../../assets/img/egg/egg4.jpg';

import { CollectionCard, CollectionCardProps } from './CollectionCard';
import { externalRoutes } from 'routing/externalRoutes';

import styles from './Gallery.module.scss';

const collections: CollectionCardProps[] = [
  {
    name: 'DuskBreakers',
    description:
      'Being a DuskBreaker means joining a select squad of 10,000 recruits who spend their days exploring a mysterious alien spaceship filled with friends, foes, and otherworldly technology.',
    imgs: [breaker1, breaker2, breaker3],
    size: 10000,
    openSeaLink: externalRoutes.openSea(),
    galleryLink: routes.gallery.duskbreakers(),
  },
  // TODO: Add gribbles here
  {
    name: 'Gribble Eggs',
    description:
      'The Gribbles are a mysterious collective of hive mind insectoids that have made an alien spaceship their home away from home. These intergalactic stowaways begin life as an adorable egg, but don’t stay that way for long.',
    imgs: [egg1, egg2, egg3],
    size: 20000,
    openSeaLink: externalRoutes.openSea(),
    galleryLink: routes.gallery.eggs(),
  },
];

const Gallery = () => {
  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="gallery"
    >
      <Helmet>
        <title>Gallery - DuskBreakers</title>
        <meta
          name="description"
          content="Explore the universe of DuskBreakers and learn more about life as a Breaker."
        />
      </Helmet>

      <div className={styles.gallery}>
        <div>
          <h1>Gallery</h1>
          <p>Take a look at all our NFT collections here.</p>
        </div>
        <div className={styles.collectionList}>
          {collections.map((item, index) => {
            return <CollectionCard key={index} {...item} />;
          })}
        </div>
      </div>

      <Footer />
    </m.main>
  );
};

export default Gallery;
